import liteguid from "lite-guid";
import GdprStorage from "../storage/GdprStorage";

/**
 *
 * This class holds the client session.
 * @author DeBro
 *
 */
export const CLIENT_SESSION_ID = "clientSessionId";
export const CLIENT_SESSION_START_TIMESTAMP = "sessionStartTimestamp";
type ClientSessionType = {
	resetClientSessionId: (...args: Array<any>) => any;
	getClientSessionId: (...args: Array<any>) => any;
	generateSessionedCallTreeIdWithPrefix: (...args: Array<any>) => any;
};

function init() {
	const put = (value: string) => {
		GdprStorage.sessionStorage.put(CLIENT_SESSION_ID, value, GdprStorage.PROMOTIONAL);
		GdprStorage.sessionStorage.put(CLIENT_SESSION_START_TIMESTAMP, Date.now().toString(), GdprStorage.PERFORMANCE);
	};

	if (!GdprStorage.sessionStorage.read(CLIENT_SESSION_ID)) {
		const _clientSessionId = liteguid.create();

		put(_clientSessionId);
	}

	return {
		/**
		 * Resets the client session id from the storage, e.g. for logout.
		 */
		resetClientSessionId: function () {
			const _newClientSessionId = liteguid.create();

			put(_newClientSessionId);
		},

		/**
		 * Gets the session id which is generated for every initialization.
		 * This means we can't track sessions over reload, but it's better than nothing.
		 */
		getClientSessionId: function () {
			return GdprStorage.sessionStorage.read(CLIENT_SESSION_ID);
		},

		/**
		 * Generates a CallTreeId with the given prefix
		 * and concatinates it with the client session id.
		 */
		generateSessionedCallTreeIdWithPrefix: function (prefix?: string | null | undefined): string {
			const usedPrefix = prefix ? prefix + "-" : "";
			const oldValue: string = GdprStorage.sessionStorage.read(CLIENT_SESSION_ID) || "";
			return oldValue + "||" + usedPrefix + liteguid.create();
		},
	};
}

export const ClientSession = init() as ClientSessionType;
